// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"64bf9759","225":"c1569ac3","242":"8a76cd04","328":"b8bbc0eb","657":"87e24079","716":"97ad4599","763":"ee93dacf","787":"052ce033","997":"87d98fe0"}[chunkId] + ".chunk.js";
};